import { Component, OnInit } from '@angular/core';
import { GlobalDataService } from '..';
import { LoginUser } from '../../_models';
import { Router } from '@angular/router';
import { AuthService, UserService, ReportService } from '../../_services';
@Component({
  standalone: false,
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.css']
})
export class LayoutComponent implements OnInit {
   currentUser!: LoginUser;
  constructor(  
    private gd : GlobalDataService, 
    private router: Router,
    private authService: AuthService,
    private userService: UserService,
    private reportService  : ReportService
  
  ) { }

  ngOnInit() {
    
   if(this.currentUser ==null){
      this.authService.authDetails("")
      .subscribe(data=> {
        if(data !=null){
          this.currentUser = data;
          this.gd.setUserData(this.currentUser);
          this.getSuppliers();
          this.getCostCenterList();
          this.getObjectAccount();
          this.getallusersList();
          this.ngOnInit();
          localStorage.setItem('currentUser', JSON.stringify(this.currentUser));
          if(this.currentUser){this.router.navigate(['/Home']);}
        }
        localStorage.setItem('currentUser', JSON.stringify(this.currentUser));

      });
      if(this.currentUser==undefined){this.router.navigate(['/NotFound']);}
    }
  }
   
  getSuppliers()
  {
    this.reportService.getSuppliers().subscribe(data=>{
      if(data!=null ) 
       this.gd.setSupplierData(data)
    });
  }

  getCostCenterList()
  {
    this.userService.getCostCenterList().subscribe(data=>{
      if(data!=null ) 
       this.gd.setCostCenterData(data)
    });
  }
  
  getObjectAccount()
  {
    this.reportService.getObjectAcunt().subscribe(data=>{
      if(data!=null ) 
      this.gd.setAccountData(data)
    });
  }

  getallusersList()
  {
    this.reportService.getallusersList().subscribe(data=>{
      if(data!=null)
      this.gd.setallusersdata(data)
    });
  }
}
